/* Centro Campo — Landing prodotto (nessuna dipendenza) */
(function () {
  'use strict';

  /* Tabelle misure ufficiali del negozio, trascritte dalle 8 immagini usate nelle schede
     prodotto e corrette nella traduzione ("Copertina" → Torace, "Mango" → Manica, metri → cm).
     h = altezza cm, w = peso kg: servono al calcolatore. */
  var CHARTS = {
    uomo: {
      name: 'Maglia Tifoso Uomo', short: 'Maglia Tifoso',
      cols: ['Lunghezza (cm)', 'Larghezza (cm)', 'Altezza (cm)', 'Peso (kg)'],
      rows: [
        ['S', '69–71', '53–55', '162–170', '50–62', [162, 170], [50, 62]],
        ['M', '71–73', '55–57', '170–176', '62–78', [170, 176], [62, 78]],
        ['L', '73–75', '57–58', '176–182', '78–83', [176, 182], [78, 83]],
        ['XL', '75–78', '58–60', '182–190', '83–90', [182, 190], [83, 90]],
        ['2XL', '78–81', '60–62', '190–195', '90–97', [190, 195], [90, 97]],
        ['3XL', '81–83', '62–64', '195–197', '97–104', [195, 197], [97, 104]],
        ['4XL', '83–85', '64–65', '197–200', '104–110', [197, 200], [104, 110]]
      ],
      fit: 'Vestibilità regolare, come le maglie dei tifosi allo stadio.'
    },
    giocatore: {
      name: 'Maglia Versione Giocatore', short: 'Versione Giocatore',
      cols: ['Lunghezza (cm)', 'Larghezza (cm)', 'Altezza (cm)', 'Peso (kg)'],
      rows: [
        ['S', '67–69', '49–51', '162–170', '50–60', [162, 170], [50, 60]],
        ['M', '69–71', '51–53', '170–175', '60–73', [170, 175], [60, 73]],
        ['L', '71–73', '53–55', '175–180', '73–78', [175, 180], [73, 78]],
        ['XL', '73–76', '55–57', '180–185', '78–83', [180, 185], [78, 83]],
        ['2XL', '76–78', '57–60', '185–190', '83–88', [185, 190], [83, 88]],
        ['3XL', '78–79', '60–63', '190–195', '88–93', [190, 195], [88, 93]]
      ],
      fit: 'Taglio aderente come in campo. Se preferisci stare comodo, prendi una taglia in più.'
    },
    donna: {
      name: 'Maglia Donna', short: 'Donna',
      cols: ['Lunghezza (cm)', 'Larghezza (cm)', 'Altezza (cm)'],
      rows: [
        ['S', '61–63', '40–41', '150–160', [150, 160]],
        ['M', '63–66', '41–44', '160–165', [160, 165]],
        ['L', '66–69', '44–47', '165–170', [165, 170]],
        ['XL', '69–71', '47–50', '170–175', [170, 175]]
      ],
      fit: 'Taglio femminile, più sciancrato in vita.'
    },
    kit_bambino: {
      name: 'Kit Bambino (maglia + pantaloncini)', short: 'Kit Bambino', kids: true,
      cols: ['Età', 'Altezza (cm)', 'Lungh. maglia', '½ Torace', 'Lungh. pantaloncini', '½ Vita (elastico)'],
      rows: [
        ['16', '2–3 anni', '95–105', '43', '32', '32', '20–37', [95, 105]],
        ['18', '3–4 anni', '105–115', '47', '34', '34', '21–39', [105, 115]],
        ['20', '4–5 anni', '115–125', '50', '36', '36', '22–41', [115, 125]],
        ['22', '6–7 anni', '125–135', '53', '38', '38', '23–42', [125, 135]],
        ['24', '8–9 anni', '135–145', '56', '40', '39', '24–44', [135, 145]],
        ['26', '10–11 anni', '145–155', '58', '42', '40', '25–47', [145, 155]],
        ['28', '12–13 anni', '155–160', '61', '44', '43', '26–50', [155, 160]]
      ],
      fit: 'La taglia indica la misura del kit, non l’età. Guarda l’altezza del bambino.'
    },
    tuta: {
      name: 'Tuta e Giacca Adulto', short: 'Tuta / Giacca',
      cols: ['Altezza (cm)', 'Peso (kg)', 'Lungh. giacca', 'Torace (circonf.)', 'Spalla', 'Lungh. pantaloni'],
      rows: [
        ['S', '161–170', '50–67', '67', '96', '74,5', '98', [161, 170], [50, 67]],
        ['M', '171–176', '62–75', '70', '100', '76', '101', [171, 176], [62, 75]],
        ['L', '176–182', '70–80', '72', '104', '77,5', '104', [176, 182], [70, 80]],
        ['XL', '182–190', '81–90', '74', '108', '79', '107', [182, 190], [81, 90]],
        ['2XL', '190–195', '91–100', '74', '112', '85,5', '110', [190, 195], [91, 100]]
      ],
      fit: 'Giacca con vestibilità sportiva, pensata per stare sopra una maglia.'
    },
    tuta_bambino: {
      name: 'Tuta Bambino', short: 'Tuta Bambino', kids: true,
      cols: ['Altezza (cm)', 'Lungh. giacca', 'Spalla', 'Manica', 'Lungh. pantaloni', 'Vita'],
      rows: [
        ['10', '115–125', '55', '40', '59,5', '78', '82', [115, 125]],
        ['12', '125–135', '57,5', '42', '61', '80', '86', [125, 135]],
        ['14', '135–145', '60', '44', '63,5', '83', '90', [135, 145]],
        ['16', '145–155', '62,5', '46', '66', '86', '94', [145, 155]],
        ['18', '155–165', '65', '48', '68,5', '89', '98', [155, 165]]
      ],
      fit: 'Se il bambino è tra due misure, scegli la più grande: la tuta durerà più a lungo.'
    },
    short: {
      name: 'Pantaloncini', short: 'Pantaloncini',
      cols: ['Larghezza vita (cm)', 'Lunghezza (cm)'],
      rows: [
        ['S', '29–31', '43–45', [162, 170], [50, 62]],
        ['M', '31–33', '45–47', [170, 176], [62, 78]],
        ['L', '33–35', '47–49', [176, 182], [78, 83]],
        ['XL', '35–37', '49–51', [182, 190], [83, 90]]
      ],
      fit: 'Vita elastica con coulisse. La larghezza è misurata da un lato all’altro, a pantaloncino steso.'
    },
    nba: {
      name: 'Canotta NBA', short: 'NBA',
      cols: ['Altezza (cm)', 'Peso (kg)', 'Lunghezza (cm)', 'Torace (circonf.)'],
      rows: [
        ['S', 'fino a 170', '55–70', '74', '108', [160, 174], [55, 70]],
        ['M', '175–180', '70–80', '76', '114', [175, 180], [70, 80]],
        ['L', '180–185', '80–90', '78', '120', [180, 185], [80, 90]],
        ['XL', '185–190', '90–100', '80', '126', [185, 190], [90, 100]],
        ['2XL', '190–195', '95–105', '82', '130', [190, 195], [95, 105]]
      ],
      fit: 'Taglio largo da basket: molti clienti scelgono la propria taglia abituale.'
    }
  };
  var ORDER = ['uomo', 'giocatore', 'donna', 'kit_bambino', 'tuta', 'tuta_bambino', 'short', 'nba'];

  var root = document.querySelector('[data-ccl]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('script[data-ccl-data]').textContent);
  var P = data.product;
  var chartKey = CHARTS[data.chart] ? data.chart : (data.chart === 'none' ? null : 'uomo');
  var state = { variant: null, qty: 1, rec: null };

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var norm = function (s) { return String(s || '').trim().toUpperCase(); };
  var money = function (cents) {
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: data.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- Coupon ---------- */
  $$('[data-ccl-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var done = function () { b.setAttribute('data-done', ''); var t = b.textContent; b.textContent = 'Copiato ✓'; setTimeout(function () { b.removeAttribute('data-done'); b.textContent = t; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(data.coupon.code).then(done, done);
      else done();
    });
  });

  /* ---------- Galleria ---------- */
  var slides = $('.ccl-slides');
  var thumbs = $$('.ccl-thumb');
  var dots = $('.ccl-dots');
  if (slides) {
    var n = slides.children.length;
    if (dots) dots.innerHTML = new Array(n + 1).join('<span></span>');
    var setActive = function (i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (dots) $$('span', dots).forEach(function (d, k) { if (k === i) d.setAttribute('data-on', ''); else d.removeAttribute('data-on'); });
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' }); setActive(i); });
    });
    var tmr;
    slides.addEventListener('scroll', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () { setActive(Math.round(slides.scrollLeft / slides.clientWidth)); }, 60);
    }, { passive: true });
    setActive(0);
  }

  /* ---------- Prezzo e taglie ---------- */
  var priceNow = $('[data-ccl-price]');
  var priceWas = $('[data-ccl-was]');
  var couponPrice = $$('[data-ccl-coupon-price]');
  var stickyPrice = $('[data-ccl-sticky-price]');
  var stickySub = $('[data-ccl-sticky-sub]');
  var sizeLabel = $('[data-ccl-size-label]');
  var sizeErr = $('[data-ccl-size-error]');
  var sizeBtns = $$('.ccl-size');

  function selectedAddons() {
    var list = [];
    var name = $('#ccl-name'), num = $('#ccl-num');
    if (data.customAddon && ((name && name.value.trim()) || (num && num.value.trim()))) list.push({ id: data.customAddon.id, price: data.customAddon.price, label: 'Nome e numero' });
    $$('[data-ccl-addon-select]').forEach(function (sel) {
      var o = sel.options[sel.selectedIndex];
      if (o && o.dataset.addon) list.push({ id: Number(o.dataset.addon), price: Number(o.dataset.price) || 0, label: o.value });
    });
    return list;
  }
  var extraBox = $('[data-ccl-extra]');
  function renderPrice() {
    var v = state.variant || P.variants[0];
    var extras = selectedAddons();
    var extra = extras.reduce(function (a, x) { return a + x.price; }, 0);
    var total = (v.price + extra) * state.qty;
    if (extraBox) {
      extraBox.hidden = !extras.length;
      extraBox.innerHTML = extras.length ? 'Extra: ' + extras.map(function (x) { return esc(x.label) + ' +' + money(x.price); }).join(' · ') + '<br><strong>Totale maglia + extra: ' + money(v.price + extra) + '</strong>' : '';
    }
    if (priceNow) priceNow.textContent = money(v.price);
    if (priceWas) { priceWas.hidden = !(v.compare > v.price); priceWas.textContent = money(v.compare || 0); }
    var disc = Math.round((v.price + extra) * (100 - data.coupon.pct) / 100);
    couponPrice.forEach(function (el) { el.textContent = money(disc); });
    if (stickyPrice) stickyPrice.textContent = money(total);
    if (stickySub) stickySub.textContent = state.variant ? ('Taglia ' + state.variant.title + (state.qty > 1 ? ' · ' + state.qty + ' pz' : '')) : 'Scegli la taglia';
  }

  function selectVariant(v, silent) {
    state.variant = v;
    sizeBtns.forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.id === String(v.id))); });
    if (sizeLabel) sizeLabel.textContent = v.title;
    if (sizeErr) sizeErr.hidden = true;
    renderPrice();
    if (!silent && history.replaceState) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
  }
  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var v = P.variants.filter(function (x) { return String(x.id) === b.dataset.id; })[0];
      if (v) selectVariant(v);
    });
  });
  if (!P.hasSizes && P.variants.length) selectVariant(P.variants[0], true);
  else {
    try {
      var pre = new URL(location.href).searchParams.get('variant');
      var pv = P.variants.filter(function (x) { return String(x.id) === pre; })[0];
      if (pv) selectVariant(pv, true);
    } catch (e) {}
  }
  renderPrice();

  var qtyIn = $('[data-ccl-qty]');
  if (qtyIn) {
    var setQty = function (q) { state.qty = Math.max(1, Math.min(20, q | 0 || 1)); qtyIn.value = state.qty; renderPrice(); };
    $$('[data-ccl-qty-step]').forEach(function (b) { b.addEventListener('click', function () { setQty(state.qty + Number(b.dataset.cclQtyStep)); }); });
    qtyIn.addEventListener('change', function () { setQty(qtyIn.value); });
  }

  /* ---------- Consegna stimata (solo giorni lavorativi) ---------- */
  function addBusinessDays(d, n) {
    var x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() + 1); var g = x.getDay(); if (g !== 0 && g !== 6) n--; }
    return x;
  }
  var eta = $('[data-ccl-eta]');
  if (eta) {
    var f = function (d) { return d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var now = new Date();
    eta.textContent = f(addBusinessDays(now, data.ship.min)) + ' e ' + f(addBusinessDays(now, data.ship.max));
  }

  /* ---------- Anteprima personalizzazione ---------- */
  var jName = $('[data-ccl-jname]'), jNum = $('[data-ccl-jnum]');
  var inName = $('#ccl-name'), inNum = $('#ccl-num');
  function fitName() {
    if (!jName) return;
    var t = norm(inName && inName.value) || 'NOME';
    jName.textContent = t;
    jName.setAttribute('font-size', t.length > 9 ? Math.max(11, 22 - (t.length - 9) * 1.6) : 22);
    jNum.textContent = (inNum && inNum.value.replace(/\D/g, '').slice(0, 2)) || '10';
  }
  if (inName) inName.addEventListener('input', function () { inName.value = inName.value.replace(/[^A-Za-z\u00C0-\u00FF'\u2019 .-]/g, '').slice(0, 14); fitName(); renderPrice(); });
  if (inNum) inNum.addEventListener('input', function () { inNum.value = inNum.value.replace(/\D/g, '').slice(0, 2); fitName(); renderPrice(); });
  $$('[data-ccl-addon-select]').forEach(function (sel) { sel.addEventListener('change', renderPrice); });
  fitName();

  /* Colore della maglia ricavato dalla prima foto prodotto */
  (function tintJersey() {
    var body = $('[data-ccl-jbody]');
    var img = $('.ccl-slide img');
    if (!body || !img) return;
    var run = function () {
      try {
        var c = document.createElement('canvas'); c.width = c.height = 40;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, 40, 40);
        var px = x.getImageData(0, 0, 40, 40).data, r = 0, g = 0, b = 0, k = 0;
        for (var i = 0; i < px.length; i += 4) {
          var R = px[i], G = px[i + 1], B = px[i + 2];
          if (R + G + B > 690 || px[i + 3] < 200) continue; // salta lo sfondo bianco
          if (Math.abs(R - G) < 14 && Math.abs(G - B) < 14 && R > 200) continue;
          r += R; g += G; b += B; k++;
        }
        if (k < 40) return;
        r = r / k | 0; g = g / k | 0; b = b / k | 0;
        body.setAttribute('fill', 'rgb(' + r + ',' + g + ',' + b + ')');
        var lum = (0.299 * r + 0.587 * g + 0.114 * b);
        $$('[data-ccl-jtext]').forEach(function (t) { t.setAttribute('fill', lum > 150 ? '#102017' : '#ffffff'); });
      } catch (e) { /* immagine non leggibile: resta il colore di default */ }
    };
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  })();

  /* ---------- Guida taglie + calcolatore ---------- */
  function tableHTML(key, hitSize) {
    var c = CHARTS[key];
    var h = '<div class="ccl-scroll"><table class="ccl-table"><thead><tr><th scope="col">Taglia</th>';
    c.cols.forEach(function (x) { h += '<th scope="col">' + x + '</th>'; });
    h += '</tr></thead><tbody>';
    c.rows.forEach(function (r) {
      h += '<tr' + (hitSize && norm(r[0]) === norm(hitSize) ? ' data-hit' : '') + '><th scope="row">' + r[0] + '</th>';
      for (var i = 1; i <= c.cols.length; i++) h += '<td>' + r[i] + '</td>';
      h += '</tr>';
    });
    return h + '</tbody></table></div>';
  }

  function recommend(key, hgt, wgt, fit) {
    var c = CHARTS[key], rows = c.rows, n = rows.length;
    var hr = function (r) { return r[c.cols.length + 1]; };
    var wr = function (r) { return c.kids || key === 'donna' ? null : r[c.cols.length + 2]; };
    var iH = n - 1, iW = -1, k;
    for (k = 0; k < n; k++) if (hgt <= hr(rows[k])[1]) { iH = k; break; }
    if (wr(rows[0])) { iW = n - 1; for (k = 0; k < n; k++) if (wgt <= wr(rows[k])[1]) { iW = k; break; } }
    var base = iW < 0 ? iH : (fit === 'aderente' ? Math.min(iH, iW) : Math.max(iH, iW));
    if (fit === 'comoda') base++;
    var over = base > n - 1 || hgt > hr(rows[n - 1])[1] + 3;
    base = Math.min(base, n - 1);
    var why;
    if (iW < 0) why = 'In base all’altezza di ' + hgt + ' cm.';
    else if (iH !== iW && fit !== 'aderente') why = 'Altezza e peso indicano taglie diverse: scegliamo la più grande, come consiglia la nostra tabella.';
    else why = 'Altezza ' + hgt + ' cm e peso ' + wgt + ' kg rientrano nella taglia ' + rows[base][0] + '.';
    if (fit === 'comoda') why += ' Una taglia in più per una vestibilità comoda.';
    return { size: rows[base][0], why: why, over: over };
  }

  function mountGuide(host, opts) {
    if (!host) return;
    var key = opts.key || chartKey || 'uomo';
    var c = CHARTS[key];
    var kids = !!c.kids, noWeight = kids || key === 'donna';
    var id = host.id || 'g';
    var finder =
      '<div class="ccl-finder">' +
        '<div><h3>Trova la tua taglia</h3><p class="ccl-finder-for">Tabella: <b data-f-for>' + c.name + '</b></p></div>' +
        '<div class="ccl-range"><div class="ccl-range-top"><label for="' + id + '-h">' + (kids ? 'Altezza del bambino' : 'La tua altezza') + '</label><output data-f-hv></output></div>' +
          '<input type="range" id="' + id + '-h" data-f-h min="' + (kids ? 90 : 145) + '" max="' + (kids ? 170 : 205) + '" step="1" value="' + (kids ? 125 : 177) + '"></div>' +
        (noWeight ? '' :
        '<div class="ccl-range"><div class="ccl-range-top"><label for="' + id + '-w">Il tuo peso</label><output data-f-wv></output></div>' +
          '<input type="range" id="' + id + '-w" data-f-w min="45" max="120" step="1" value="76"></div>') +
        (kids ? '' :
        '<fieldset style="border:0;padding:0;margin:0;display:grid;gap:6px"><legend class="ccl-label" style="padding:0;margin-bottom:6px">Come ti piace la maglia?</legend><div class="ccl-seg">' +
          ['aderente', 'regolare', 'comoda'].map(function (f) {
            return '<label><input type="radio" name="' + id + '-fit" value="' + f + '"' + (f === 'regolare' ? ' checked' : '') + '><span>' + f.charAt(0).toUpperCase() + f.slice(1) + '</span></label>';
          }).join('') + '</div></fieldset>') +
        '<div class="ccl-result" data-f-res aria-live="polite"></div>' +
      '</div>';
    var tables = '<div class="ccl-tables">';
    if (opts.tabs) {
      tables += '<div class="ccl-tabs" role="tablist" aria-label="Tabelle misure">';
      ORDER.forEach(function (k) {
        tables += '<button type="button" class="ccl-tab" role="tab" data-tab="' + k + '"' + (k === chartKey ? ' data-mine' : '') + ' aria-selected="' + (k === key) + '">' + CHARTS[k].short + '</button>';
      });
      tables += '</div>';
    }
    tables += '<div class="ccl-tablebox" role="tabpanel"><div class="ccl-tablebox-head"><h3 data-t-title></h3><span data-t-mine class="ccl-chip ccl-chip--green">La tabella di questo prodotto</span></div><div data-t-body></div><p class="ccl-note" data-t-fit></p><p class="ccl-note">Misure prese a capo steso. Possibili differenze di 2–4 cm. Se sei tra due taglie, scegli la più grande.</p></div>';
    if (opts.measure) {
      tables += '<div class="ccl-measure"><svg class="ccl-measure-svg" width="120" height="120" viewBox="0 0 120 120" aria-hidden="true"><path d="M38 10 L22 16 L6 40 L22 50 L28 42 L28 112 L92 112 L92 42 L98 50 L114 40 L98 16 L82 10 Q60 24 38 10 Z" fill="#e9f3ec" stroke="#102017" stroke-width="2.5" stroke-linejoin="round"/><line x1="30" y1="52" x2="90" y2="52" stroke="#e8a800" stroke-width="3"/><circle cx="60" cy="52" r="7" fill="#e8a800"/><text x="60" y="56" font-size="9" font-weight="700" text-anchor="middle" fill="#102017">A</text><line x1="104" y1="12" x2="104" y2="112" stroke="#e8a800" stroke-width="3"/><circle cx="104" cy="66" r="7" fill="#e8a800"/><text x="104" y="70" font-size="9" font-weight="700" text-anchor="middle" fill="#102017">B</text></svg>' +
        '<ul><li><b>A</b>Larghezza: da ascella ad ascella, maglia stesa.</li><li><b>B</b>Lunghezza: dal punto più alto della spalla all’orlo.</li><li>Il trucco più sicuro: misura una maglia che ti sta bene e confrontala con la tabella.</li></ul></div>';
    }
    tables += '</div>';
    host.innerHTML = (opts.tabs ? '<div class="ccl-size-grid">' + finder + tables + '</div>' : finder + tables);

    var cur = key;
    var hIn = $('[data-f-h]', host), wIn = $('[data-f-w]', host), res = $('[data-f-res]', host);
    function drawTable(hit) {
      $('[data-t-title]', host).textContent = CHARTS[cur].name;
      $('[data-t-mine]', host).hidden = cur !== chartKey;
      $('[data-t-body]', host).innerHTML = tableHTML(cur, cur === key ? hit : null);
      $('[data-t-fit]', host).textContent = CHARTS[cur].fit;
    }
    function update() {
      var hv = +hIn.value, wv = wIn ? +wIn.value : 0;
      $('[data-f-hv]', host).textContent = hv + ' cm';
      if (wIn) $('[data-f-wv]', host).textContent = wv + ' kg';
      var fitEl = $('input[name="' + id + '-fit"]:checked', host);
      var r = recommend(key, hv, wv, fitEl ? fitEl.value : 'regolare');
      var v = P.variants.filter(function (x) { return norm(x.title) === norm(r.size); })[0];
      var can = v && v.available;
      res.className = 'ccl-result' + (can ? '' : ' ccl-result--off');
      res.innerHTML = '<div class="ccl-result-size">' + r.size + '</div><strong>' + (r.over ? 'La taglia più grande disponibile' : 'La tua taglia ideale') + '</strong><p>' + esc(r.why) + '</p>' +
        (key === chartKey && P.hasSizes ? (can ? '<button type="button" class="ccl-btn" data-f-pick>Scegli la taglia ' + r.size + '</button>' : '<p>Questa taglia non è disponibile per questo prodotto.</p>') : '');
      var pick = $('[data-f-pick]', res);
      if (pick) pick.addEventListener('click', function () {
        selectVariant(v);
        markRec(r.size);
        var dlg = document.getElementById('ccl-guide-dialog');
        if (dlg && dlg.open) dlg.close();
        var box = $('.ccl-buy');
        if (box && opts.tabs) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      if (cur === key) drawTable(r.size);
    }
    hIn.addEventListener('input', update);
    if (wIn) wIn.addEventListener('input', update);
    $$('input[type="radio"]', host).forEach(function (x) { x.addEventListener('change', update); });
    $$('.ccl-tab', host).forEach(function (t) {
      t.addEventListener('click', function () {
        cur = t.dataset.tab;
        $$('.ccl-tab', host).forEach(function (o) { o.setAttribute('aria-selected', String(o === t)); });
        if (cur === key) update(); else drawTable(null);
      });
    });
    drawTable(null);
    update();
  }
  function markRec(size) {
    sizeBtns.forEach(function (b) { if (norm(b.textContent) === norm(size)) b.setAttribute('data-rec', ''); else b.removeAttribute('data-rec'); });
  }

  mountGuide(document.getElementById('ccl-guide-page'), { tabs: true, measure: true });
  var dlg = document.getElementById('ccl-guide-dialog');
  if (dlg && chartKey) {
    mountGuide($('[data-ccl-dialog-body]', dlg), { tabs: false, measure: false });
    $$('[data-ccl-open-guide]').forEach(function (b) {
      b.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else document.getElementById('ccl-guide-page').scrollIntoView(); });
    });
    $$('[data-ccl-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  } else {
    $$('[data-ccl-open-guide]').forEach(function (b) { b.hidden = true; });
  }

  /* ---------- Carrello ---------- */
  function properties() {
    var p = {};
    var name = norm(inName && inName.value), num = inNum && inNum.value;
    if (name || num) p['Personalizzazione'] = [name, num].filter(Boolean).join(' ');
    var map = { 'ccl-patch': 'Patch  (a)', 'ccl-note': 'Osservazione  (b)', 'ccl-shorts': 'Pantaloncini  (c)', 'ccl-socks': 'Calzettoni  (d)' };
    Object.keys(map).forEach(function (k) {
      var el = document.getElementById(k);
      if (el && el.value.trim()) p[map[k]] = el.value.trim();
    });
    return p;
  }
  function needSize() {
    if (state.variant) return false;
    var picker = $('.ccl-sizes');
    if (sizeErr) sizeErr.hidden = false;
    if (picker) {
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      picker.classList.remove('ccl-shake'); void picker.offsetWidth; picker.classList.add('ccl-shake');
    }
    return true;
  }
  var toast = $('[data-ccl-toast]');
  function showToast(msg) {
    if (!toast) return;
    $('[data-ccl-toast-msg]', toast).textContent = msg;
    toast.hidden = false;
    clearTimeout(showToast.t);
    showToast.t = setTimeout(function () { toast.hidden = true; }, 8000);
  }
  if (toast) $('[data-ccl-toast-close]', toast).addEventListener('click', function () { toast.hidden = true; });

  function checkoutURL() {
    return data.coupon.autoApply ? '/discount/' + encodeURIComponent(data.coupon.code) + '?redirect=%2Fcheckout' : '/checkout';
  }
  function add(btn, thenCheckout) {
    if (needSize()) return;
    btn.setAttribute('aria-busy', 'true');
    var forWhat = P.title + ' (' + state.variant.title + ')';
    var items = [{ id: state.variant.id, quantity: state.qty, properties: properties() }];
    selectedAddons().forEach(function (x) { items.push({ id: x.id, quantity: state.qty, properties: { 'Per': forWhat } }); });
    var body = { items: items };
    if (data.preview) {
      setTimeout(function () { btn.removeAttribute('aria-busy'); showToast('Anteprima: ' + P.title + ' · taglia ' + state.variant.title + ' aggiunta.'); }, 400);
      return;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (thenCheckout) { location.href = checkoutURL(); return; }
        btn.removeAttribute('aria-busy');
        if (document.getElementById('mini-cart')) {
          /* Gaveta do tema: sobe a página (o cabeçalho não é fixo) e abre o carrinho já atualizado */
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(function () {
            if (window.scrollY > 40) window.scrollTo(0, 0);
            document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: state.variant, quantity: state.qty } }));
          }, 450);
          return;
        }
        showToast(P.title + ' · taglia ' + state.variant.title + ' è nel carrello.');
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          $$('.cart-count-bubble span, [data-cart-count], .cart-count, .header__cart-count, .cart_count').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: c }));
        }).catch(function () {});
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        showToast((err && (err.description || err.message)) || 'Non siamo riusciti ad aggiungere il prodotto. Riprova o scrivici su WhatsApp.');
      });
  }
  $$('[data-ccl-add]').forEach(function (b) { b.addEventListener('click', function () { add(b, false); }); });
  $$('[data-ccl-buynow]').forEach(function (b) { b.addEventListener('click', function () { add(b, true); }); });
  $$('[data-ccl-checkout]').forEach(function (a) { if (!data.preview) a.setAttribute('href', checkoutURL()); });

  /* ---------- Barra fissa mobile ---------- */
  var sticky = document.querySelector('[data-ccl-sticky]');
  var mainBtn = $('[data-ccl-add]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0];
      if (!e.isIntersecting && e.boundingClientRect.top < 0) sticky.setAttribute('data-show', ''); else sticky.removeAttribute('data-show');
    }).observe(mainBtn);
    $('[data-ccl-sticky-btn]', sticky).addEventListener('click', function (ev) {
      if (!state.variant) { needSize(); return; }
      add(ev.currentTarget, false);
    });
  }
  $$('[data-ccl-top]').forEach(function (b) {
    b.addEventListener('click', function () { var t = $('.ccl-buy'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  });

  /* ---------- Prodotti correlati ---------- */
  var recBox = $('[data-ccl-recs]');
  if (recBox && !data.preview && window.fetch) {
    fetch('/recommendations/products.json?product_id=' + P.id + '&limit=4&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var list = (j.products || []).slice(0, 4);
        if (!list.length) return;
        $('[data-ccl-recs-grid]', recBox).innerHTML = list.map(function (p) {
          var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400') : '';
          return '<a class="ccl-rec" href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400"><span>' + esc(p.title) + '</span><b>' + money(p.price) + '</b></a>';
        }).join('');
        recBox.hidden = false;
      }).catch(function () {});
  }
})();
